import { VariantProps } from 'tailwind-variants';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';

import { styles } from './NavButton.styles';

type Variants = VariantProps<typeof styles>;

export interface NavButtonProps {
  direction?: Variants['direction'];
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export function NavButton({
  direction = 'prev',
  onClick,
  disabled,
  className
}: NavButtonProps) {
  const slots = styles({ direction });

  return (
    <button
      className={slots.base({ className })}
      onClick={onClick}
      disabled={disabled}
    >
      <ChevronIcon className={slots.icon()} />
    </button>
  );
}
